import React, { useState } from 'react';

function AdminUploadTestPage() {
    const [selectedFile, setSelectedFile] = useState(null);
    const [message, setMessage] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setMessage('');
        setImageUrl('');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!selectedFile) {
            setMessage('Please select a file first.');
            return;
        }

        setIsLoading(true);
        setMessage('Uploading...');
        setImageUrl('');

        const formData = new FormData();
        formData.append('newsImage', selectedFile);

        const token = localStorage.getItem('jwt_token'); // Correct key for the auth token
        if (!token) {
            setMessage('Authentication token not found. Please log in.');
            setIsLoading(false);
            return;
        }

        try {
            const apiBaseUrl = import.meta.env.VITE_API_URL || 'http://localhost:4000';
            const response = await fetch(`${apiBaseUrl}/api/upload/news-image`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    // 'Content-Type': 'multipart/form-data' is not needed; browser sets it with boundary
                },
                body: formData,
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Upload successful!');
                setImageUrl(data.imageUrl);
                console.log('Uploaded image URL:', data.imageUrl);
            } else {
                setMessage(`Upload failed: ${data.error || response.statusText}`);
                setImageUrl('');
            }
        } catch (error) {
            console.error('Upload error:', error);
            setMessage(`Upload error: ${error.message}`);
            setImageUrl('');
        }
        setIsLoading(false);
    };

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h2>Admin News Image Upload Test</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="fileInput">Choose image to upload:</label><br />
                    <input 
                        type="file" 
                        id="fileInput" 
                        accept="image/jpeg, image/png, image/gif, image/webp" 
                        onChange={handleFileChange} 
                        style={{ margin: '10px 0' }}
                    />
                </div>
                <button type="submit" disabled={isLoading || !selectedFile} style={{ padding: '10px 15px', cursor: 'pointer' }}>
                    {isLoading ? 'Uploading...' : 'Upload Image'}
                </button>
            </form>
            {message && <p style={{ marginTop: '20px', color: imageUrl ? 'green' : 'red' }}>{message}</p>}
            {imageUrl && (
                <div style={{ marginTop: '20px' }}>
                    <p>Image uploaded to: {imageUrl}</p>
                    <p>You can try accessing it at: <a href={`${import.meta.env.VITE_API_URL || ''}${imageUrl}`} target="_blank" rel="noopener noreferrer">{`${import.meta.env.VITE_API_URL || ''}${imageUrl}`}</a> (if backend serves it from root) or directly <a href={imageUrl} target="_blank" rel="noopener noreferrer">{imageUrl}</a> (if path is absolute and served by a CDN or similar)</p>
                    <img src={`${import.meta.env.VITE_API_URL || ''}${imageUrl}`} alt="Uploaded preview" style={{ maxWidth: '300px', marginTop: '10px', border: '1px solid #ccc' }} />
                </div>
            )}
        </div>
    );
}

export default AdminUploadTestPage;
